import { Injectable } from '@angular/core';

@Injectable()
export class Settings {
    apiUrl = 'https://apicms.webmonkeyz.com/api/';
    websiteId = 11;
    googleAnalyticsId = '';
    emailTo = 'angelcryptband@gmail.com';
    emailFrom = 'noreply@web-monkeyz.com';
    userLogged = false;
}